import { AutosuggestWidget } from "./AutosuggestWidget";
import { BaseInput } from "./BaseInput";
import { CheckboxesWidget } from "./CheckboxesWidget";
import { CheckboxWidget } from "./CheckboxWidget";
import { ColorWidget } from "./ColorWidget";
import { ConsentWidget } from "./ConsentWidget";
import { DateTimeWidget } from "./DateTimeWidget";
import { DateWidget } from "./DateWidget";
import { EmailWidget } from "./EmailWidget";
import { Widget } from "./models";
import { NumericWidget } from "./NumericWidget";
import { PasswordWidget } from "./PasswordWidget";
import { PhoneNumberWidget } from "./PhoneNumberWidget";
import { RadioWidget } from "./RadioWidget";
import { ReadOnlyDeviationChipWidget } from "./ReadOnlyDeviationChipWidget";
import { ReadOnlyWidget } from "./ReadOnlyWidget";
import { RichTextEditorWidget } from "./RichTextEditorWidget";
import { SelectWidget } from "./select-widget";
import { SwitchWidget } from "./SwitchWidget";
import { TextareaWidget } from "./TextareaWidget";
import { TextWidget } from "./TextWidget";
import { TitleWidget } from "./TitleWidget";
import { VersionedEventRevisionNumberReadOnlyWidget } from "./VersionedEventRevisionNumberReadOnlyWidget";

export { BaseInput } from "./BaseInput";
export * from "./helpers";
export * from "./models";
export { RadioWidget } from "./RadioWidget";
export { ReadOnlyWidget } from "./ReadOnlyWidget";

export const widgetRegistry: { [name: string]: Widget<any> } = {
  AutosuggestWidget,
  BaseInput,
  CheckboxesWidget,
  CheckboxWidget,
  ColorWidget,
  ConsentWidget,
  NumericWidget,
  DateTimeWidget,
  DateWidget,
  EmailWidget,
  PasswordWidget,
  PhoneNumberWidget,
  RadioWidget,
  ReadOnlyWidget,
  ReadOnlyDeviationChipWidget,
  RichTextEditorWidget,
  SelectWidget,
  SwitchWidget,
  TextareaWidget,
  TextWidget,
  TitleWidget,
  VersionedEventRevisionNumberReadOnlyWidget,
};
